module.exports = __webpack_public_path__ + "static/media/flyerM42.8749a522.webp";